import request from "root/js/request";

export const getAnalyticsCrossMPOrdersWidget = async ({
  cabinet_id__in,
  extra_fields,
  ...rest
}) => {
  const response = await request({
    url: "/analytics/cross-mp/orders_widget/",
    method: "get",
    params: {
      cabinet_id__in,
      extra_fields,
      ...rest,
    },
  });
  return response.data;
};
